import { render } from "./ParallaxAbout.vue?vue&type=template&id=615f1592"
import script from "./ParallaxAbout.vue?vue&type=script&lang=js"
export * from "./ParallaxAbout.vue?vue&type=script&lang=js"

import "./ParallaxAbout.vue?vue&type=style&index=0&id=615f1592&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__